<div class="content-wrapper" >
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> </h4>
         
  
            <div  style="text-align: center; padding: 18px;">
              <h4 style="color: rgba(128, 128, 128, 0.741); ">This request completed succesfully</h4>
            </div>

                          <!-- Approvals -->
<div class="card-body" >
 

<div  style="text-align: center; padding: 18px;">
    <button class="btn btn-primary" style="margin-right: 8px;"  (click)="cancel()">Close</button>
  </div>


</div>
     
          </div>
        </div>
      </div>
  
  
    </div>
  </div>
